import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/contents/tms-2/is-tms-right-for-me")({
  beforeLoad: () => {
    throw redirect({ to: "/contents/tms/is-tms-right-for-me" });
  },
});
